// Modules
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GridModule } from '@progress/kendo-angular-grid';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { UploadModule } from '@progress/kendo-angular-upload';
// Components
import { SharedModule } from '../../shared/shared.module';
import { BulkAddRoutingModule } from './bulk-add-routing.module';
import { BulkAddAssetsComponent } from './components/assets/bulk-add-assets.component';
import { ProductWarrantyComponent } from './components/product-warranty/product-warranty.component';
import { BulkAddProductsComponent } from './components/products/bulk-add-products.component';
import { BulkAddAssetsService } from './service/bulk-add-assets.service';
import { BulkAddProductsService } from './service/bulk-add-products.service';

@NgModule({
  imports: [
    CommonModule,
    GridModule,
    UploadModule,
    NgbModule,
    SharedModule,
    BulkAddRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    LayoutModule
  ],
  declarations: [
    BulkAddAssetsComponent,
    BulkAddProductsComponent,
    ProductWarrantyComponent
  ],
  providers: [BulkAddAssetsService, BulkAddProductsService]
})
export class BulkAddModule {}
